import { getIsPageVisible } from '@office-start/page-visibility-service';
import { mark, mark as markPerformance, } from '@office-start/performance-service';
import { useEffect, useRef } from 'react';
export function useRecommendedInstrumentation(_a) {
    var dataResult = _a.dataResult, canRender = _a.canRender, paintMarker = _a.paintMarker;
    var isPaintMarkerRecorded = useRef(false);
    var isReadyMarkerRecorded = useRef(false);
    useEffect(function () {
        if (!isReadyMarkerRecorded.current) {
            var data = dataResult === null || dataResult === void 0 ? void 0 : dataResult.result.documents;
            if (data) {
                markPerformance((dataResult === null || dataResult === void 0 ? void 0 : dataResult.fromPersistence)
                    ? "Cached_Recommended_Ready"
                    : "Recommended_Ready");
                isReadyMarkerRecorded.current = true;
            }
        }
    }, [dataResult]);
    // Mark Recommended Paint
    useEffect(function () {
        if (canRender) {
            if (!isPaintMarkerRecorded.current) {
                if (getIsPageVisible()) {
                    mark(paintMarker);
                }
                isPaintMarkerRecorded.current = true;
            }
        }
    }, [canRender, paintMarker]);
}
//# sourceMappingURL=useRecommendedInstrumentation.js.map